import React from 'react';
import { StyleSheet } from 'react-native';

import CheckmarkThin from '@/assets/icons/checkmark-thin';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';
import { Rafv2DocumentDataActiveReferralsStepsItem } from '@/types/prismic.generated';

type Step = Rafv2DocumentDataActiveReferralsStepsItem & { completedOn?: string };

const getStepColor = (isCompleted: boolean | undefined, shouldCompleteNextStep: boolean) => {
    if (isCompleted === undefined) {
        return 'neutral700';
    }
    if (shouldCompleteNextStep) {
        return ds.colorToken.background.neutral.inverse;
    }
    return isCompleted ? ds.colorToken.background.neutral.inverse : 'neutral500';
};

export const LineSteps = ({ steps }: { steps?: Step[] }) => {
    return steps?.map((step, index) => {
        const stepText = step.step;

        //TODO: Implement the logic for isCompleted and shouldCompleteNextStep when BE is ready
        const isCompleted = index === 0 || index === 1;
        const shouldCompleteNextStep = index === 2;

        const stepsColor = getStepColor(isCompleted, shouldCompleteNextStep);
        const lineColor = getStepColor(isCompleted, false);
        return (
            <Box key={`${stepText} - ${index.toString()}`}>
                <Row
                    paddingBottom={'s16'}
                    alignItems={step.completedOn ? 'flex-start' : 'center'}
                    position={'relative'}
                    key={index}
                >
                    <Box
                        width={24}
                        borderRadius={'r22'}
                        borderWidth={2}
                        borderColor={stepsColor}
                        alignItems={'center'}
                        justifyContent={'center'}
                        paddingVertical={shouldCompleteNextStep ? 's6' : 's2'}
                        backgroundColor={isCompleted ? ds.colorToken.background.neutral.inverse : 'transparent'}
                    >
                        {isCompleted ? (
                            <CheckmarkThin color={designSystem.colors.neutral600} />
                        ) : shouldCompleteNextStep ? (
                            <Box
                                width={8}
                                height={8}
                                backgroundColor={ds.colorToken.background.neutral.inverse}
                                borderRadius={'r12'}
                                padding={'s2'}
                            />
                        ) : (
                            <Text variant={'labelMedium'} color={ds.colorToken.text.secondary}>
                                {index + 1}
                            </Text>
                        )}
                    </Box>
                    <Box alignItems={'flex-start'} justifyContent={'flex-start'} marginLeft={'s16'}>
                        <Text variant={'bodyMedium'} color={ds.colorToken.text.primary}>
                            {stepText}
                        </Text>
                        {/*TODO: completedOn when BE is ready*/}
                        {step.completedOn ? (
                            <Text variant={'bodySmall'} color={ds.colorToken.text.secondary}>
                                {step.completedOn}
                            </Text>
                        ) : null}
                    </Box>
                </Row>
                {index < steps.length - 1 && (
                    <Box height={step.completedOn ? 38 : 18} style={styles.line} backgroundColor={lineColor} />
                )}
            </Box>
        );
    });
};

const styles = StyleSheet.create({
    line: {
        position: 'absolute',
        left: 11,
        top: 24,
        width: 2,
    },
});
